// extracted by mini-css-extract-plugin
export default {"upcomingBadge":"ComingSoonBadge_upcomingBadge__k-Qv9"};